import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { setDomainUrl } from "./utils/helpers";
import { registerNavigate } from "./utils/navigateHandler";
import NotificationProvider from "./context/notificationProvider";

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    // Register navigate when app mounts
    registerNavigate(navigate);
  }, [navigate]);

  useEffect(() => {
    setDomainUrl();
  }, []);

  return (
    <>
      <NotificationProvider />
      <Outlet />
    </>
  );
}

export default App;
